export default {
  goodDeal: { id: 'good_deal', defaultMessage: 'Hot deal' },
  comingSoon: {
    id: 'product_page_customization_coming_soon',
    defaultMessage: 'Coming soon',
  },
  soldOut: {
    id: 'already_sold',
    defaultMessage: 'Sold out',
  },
  selected: {
    id: 'product_page_customization_selected_price',
    defaultMessage: 'Current',
  },
  bestDealTitle: {
    id: 'product_page_price_opportunity_title',
    defaultMessage: 'Rare price',
  },
  bestDealGradesDescription: {
    id: 'product_page_price_opportunity_message_grades',
    defaultMessage:
      'Right now you can get a better condition for a lower price. Lucky you!',
  },
}
